<template>
  <div>
    <nav class="navbar navbar-expand-md navbar-dark bg-dark">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <h1 class="navbar-brand mb-0">
        <a href="/home">
          EM<img src="/img/DragonMedium.png" height="40">ERS
          <span>RPG Vault</span>
        </a>
      </h1>
      <span class="status-group">
        <router-link v-if="ruleset" class="status" data-toggle="tooltip" data-placement="bottom" data-html="true"
          :title="`<div class='text-left'><strong>${ruleset}</strong><br>You are currently using the ${ruleset} ruleset. You can switch rulesets under your user settings.</div>`"
          to="/ruleset">{{activeRuleset}}</router-link>
        <span class="status version d-none d-sm-inline">v1.3</span>
      </span>
      <div class="collapse navbar-collapse" id="navbarNav">
        <div v-if="isAuthenticated && ruleset" class="navbar-nav mr-auto">
          <router-link class="nav-item nav-link" data-toggle="collapse" data-target=".navbar-collapse.collapse.show"
            to="/characters">Characters</router-link>
          <router-link class="nav-item nav-link" data-toggle="collapse" data-target=".navbar-collapse.collapse.show"
            to="/rules">Rulebook</router-link>
          <router-link v-if="ruleset !== 'Solarian Conflict'" class="nav-item nav-link" data-toggle="collapse"
            data-target=".navbar-collapse.collapse.show" to="/spells">{{spellbookName}}
          </router-link>
          <router-link class="nav-item nav-link" data-toggle="collapse" data-target=".navbar-collapse.collapse.show"
            to="/items">Armory</router-link>
        </div>
        <div v-else class="navbar-nav mr-auto"></div>
        <div class="navbar-nav">
          <router-link class="nav-item nav-link" data-toggle="collapse" data-target=".navbar-collapse.collapse.show"
            to="/faqs">FAQs</router-link>
          <router-link class="nav-item nav-link" data-toggle="collapse" data-target=".navbar-collapse.collapse.show"
            to="/sign-in" v-if="!isAuthenticated">Sign In</router-link>
          <span class="nav-item dropdown" v-if="isAdmin">
            <a class="nav-link dropdown-toggle" href="/" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false">Admin</a>
            <div class="dropdown-menu">
              <router-link class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.collapse.show"
                to="/achievements">Achievements</router-link>
              <router-link class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.collapse.show"
                to="/pages">Pages</router-link>
              <router-link class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.collapse.show"
                to="/users">Users</router-link>
              <router-link class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.collapse.show"
                to="/reports">Reports</router-link>
            </div>
          </span>
          <span class="nav-item dropdown" v-if="isAuthenticated">
            <a class="nav-link dropdown-toggle" href="/" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false" @click="getData()">{{user.name}}</a>
            <div class="dropdown-menu dropdown-menu-right">
              <div class="text-center avatar">
                <img :src="user.image">
                <div v-if="user.roles.length > 0" class="text-center">
                  <span v-for="role in user.roles" :key="role" class="badge badge-dark">{{role.toUpperCase()}}</span>
                </div>
              </div>
              <div v-if="user.achievements && user.achievements.length > 0" class="text-center">
                <div class="dropdown-divider"></div>
                <h6>Achievements</h6>
                <ez-badges v-for="achievement in user.achievements" :item="achievement"
                  :key="achievement._id"></ez-badges>
              </div>
              <div class="dropdown-divider"></div>
              <router-link class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.collapse.show"
                :to="`/users/${user._id}/settings`">Settings</router-link>
              <router-link class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.collapse.show"
                to="/sign-in" @click.native="signOut()">Sign Out</router-link>
            </div>
          </span>
        </div>
      </div>
    </nav>
    <div v-if="isAuthenticated && !isSupporter &!isAdmin" class="alert alert-secondary patreon-notice text-center"
      role="warning">
      <i class="fa fa-gift"></i> Support us on <strong><a href="https://www.patreon.com/EmbersRPGVault"
          target="patreon">Patreon</a></strong> to unlock unlimited
      characters! <i class="fa fa-gift"></i>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import EzBadges from "@/components/shared/_VueEzBadges";

export default {
  name: "navbar",
  components: {
    EzBadges,
  },
  watch: {
    user: "setBackground",
  },
  mounted() {
    /* eslint-disable no-undef */
    $('[data-toggle="tooltip"]').tooltip();
    this.setBackground();
  },
  computed: {
    ...mapGetters(["isAuthenticated", "isAdmin", "isGm", "isSupporter"]),
    ...mapState({
      user: (state) => state.session.user,
    }),
    ruleset() {
      if (!this.user || !this.user.settings) this.signOut();
      return this.user && this.user.settings && this.user.settings.ruleset
        ? this.user.settings.ruleset
        : null;
    },
    activeRuleset() {
      let r = this.ruleset;
      r = r === "5th Edition" ? "5e14" : r;
      r = r === "5e 2024" ? "5e24" : r;
      return r;
    },
    spellbookName() {
      var label = ["Savage Worlds"].includes(this.ruleset)
        ? "Powerbook"
        : "Spellbook";
      return label;
    },
  },
  methods: {
    ...mapActions({
      signOut: "signOut",
      updateProfile: "updateProfile",
    }),
    setBackground() {
      // let body = document.getElementsByTagName("body")[0];
      if (this.user && this.user.settings && this.user.settings.darkMode) {
        $("body").addClass("dark-mode");
      } else {
        $("body").removeClass("dark-mode");
      }
    },
    async getData() {
      try {
        this.updateProfile();
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/_global";

.patreon-notice {
  margin-top: -.75em;
  font-size: 1.25em;
}

.navbar {
  padding: 0 0.5rem;
}

.navbar-toggler {
  padding: 0 0.25rem;
  margin: 0.2rem;
}
.navbar-brand {
  padding-top: .15rem !important;
  padding-bottom: 0!important;
}
.navbar-brand > a {
  color: #ff5800;
  &:hover {
    color: #ff5800;
    text-decoration: none;
  }
  span {
    color: rgba(255, 255, 255, 0.2);
  }
}
.dropdown-menu {
  border-top: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  margin: 0;
}
.avatar {
  margin: 0.5em;
  img {
    border-radius: 50%;
    width: 4rem;
    height: 4rem;
  }
}
h6 {
  color: $gray-500;
}

.status-group {
  margin-right: 0.4em;
  margin-top: -0.2em;
}

.status {
  font-weight: bold;
  color: #ff5800;
  border: 1px solid $gray-700;
  font-size: 0.675em;
  font-weight: bold;
  padding: 0.2em;
  &:hover {
    border: 1px solid #ff5800;
    cursor: pointer;
  }
}
</style>
